<div class="appbar-container bg-yc-background-default border-0 border-b border-b-yc-border-default border-solid mb-2"
  >
  <div class="px-4 py-2 justify-between relative flex sh-medium">
    <div class="gap-2 flex items-center">

      <i *ngIf="route || back" class="ri-arrow-left-line cursor-pointer h-large" (click)="goToRoute()"></i>
      <i *ngIf="!route && !back" class="ri-menu-fold-line cursor-pointer h-large scale-x-[-1]"
        (click)="toggleNavigation()"></i>
        <span class="text-base font-medium">{{ title }}</span>
      <ng-content select="[slot=start]"></ng-content>
    </div>
    <ng-content select="[slot=end]"></ng-content>

    <div class="absolute left-0 right-0 h-2x-small">
      <ng-content></ng-content>
    </div>
  </div>
</div>